import {  STORE_DEATILS_ACTION } from 'core/constants/Actions'
import { TypedThunk, TypedDispatch } from 'App/Store'
import { getStoreById } from 'core/services/Store'

export function getStore(storeId: number | string): TypedThunk {
  return async (dispatch: TypedDispatch) => {
    dispatch({ type: STORE_DEATILS_ACTION.REQUEST })
    const apiResponse = await getStoreById(storeId)
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: STORE_DEATILS_ACTION.SUCCESS,
        payload: { store: apiResponse.data.store }
      })
    } else {
      dispatch({
        type: STORE_DEATILS_ACTION.FAILURE
      })
    }
  }
}

export function resetStoreDetails() {
  return {
    type: STORE_DEATILS_ACTION.RESET
  }
}